import type { ReactNode } from 'react';
import { signOut } from '../../components/shell/UserMenu';

export interface AuthCardProps {
  readonly title: string;
  readonly email: string;
  readonly children: ReactNode;
}

/** The sign-in steps after Keycloak (W20): the card of AccessGate's screens, no shell. */
export function AuthCard({ title, email, children }: AuthCardProps) {
  return (
    <main className="grid min-h-screen place-items-center bg-bg-2 p-6 text-[14px] text-fg-1">
      <section aria-labelledby="auth-title" className="flex w-full max-w-[420px] flex-col gap-3 rounded-3 border border-border-1 bg-bg-1 p-6">
        <header className="flex flex-col gap-1">
          <h1 id="auth-title" className="text-[18px] font-semibold text-fg-1">
            {title}
          </h1>
          <p className="text-[13px] text-fg-2">
            {email} ·{' '}
            <button type="button" className="text-fg-2 underline underline-offset-2 hover:text-fg-1" onClick={() => void signOut()}>
              Выйти
            </button>
          </p>
        </header>
        {children}
      </section>
    </main>
  );
}
